import { Subject ,  BehaviorSubject } from'rxjs';

import { XAPIRunner } from 'libs-frontend-xapi/dist/js/xapirunner.js';
import { XAPIAnalytics } from 'libs-frontend-xapi/dist/js/xapianalytics.js';
import Raven from 'raven-js';
import { RecordingHelperService } from './recording-helper.service';
import { Injectable } from '@angular/core';

// declare global {
//   interface Window { XAPIRunner: any; }
// }
// window.XAPIRunner = XAPIRunner;

@Injectable()
export class ProductViewHelperService {

  selectedItemId = new Subject();
  changesNotSaved = new Subject<void>();
  pskillUrlLinkValidation = new Subject<any>();
  pskillAnsSaved:Subject<any> = new Subject<any>();
  collabSkillAnsSaved = new Subject<void>();
  saveAlertAction: Subject<boolean> = new Subject<boolean>();
  logOutCalled = new Subject<void>();
  saveAlertActionOnLogout = new Subject<void>();
  stopAllOtherAudiosOnPlayingOneAudio = new Subject<number>();
  activityEventsSubject = new Subject<any>();
  closeActivityBtnSubject = new Subject<any>();
  showContentAccessItemsUpdatedMsg = new Subject<any>();
  showSetRulePageSubject = new BehaviorSubject<any>({});
  itemsUpdatedAfterSetRuleInitiationSubject = new Subject<any>();
  resetTocSelectionSubject = new Subject<any>();
  leaveSetRulePage = new Subject<boolean>();


  private productTocData : any;
  private productCode : string;
  private productResultsDisplayData: any;
  private isTestTypeProduct: boolean = false;
  private isAssignmentOnlyProduct = false;
  private classId : string;
  private isCBPClass: boolean = false;
  private classData: object;
  private xapiLO: any;
  private xapiLOAnalytics: any;
  private isPreviewMode: boolean;
  private initParams: any;
  private navigationMeta: any;
  private segment: string;
  scoreDetailFormatTypes = {
    mock: "MOCK",
    none: "none"
  }
  productModelTypes = {
    test: 'TEST'
  }
  private activityTimings: any = {};

  constructor(
    private recordingHelperService: RecordingHelperService,
  ) { }

  setProductClass(productCode, classId, classDetails, productResultsDisplayData: any = {}, isTestTypeProduct = false) {
      this.productCode = productCode;
      this.isTestTypeProduct = isTestTypeProduct;
      this.classId = classId;
      if (classDetails) {
        this.classData = classDetails.class || {};
        this.isCBPClass = classDetails.analyticsharingmodel === 'NOINHERIT_SYNCBACK';
      } else {
        this.classData = {};
      }
      this.productResultsDisplayData = productResultsDisplayData;
  }

  getNavigationMeta() {
    return this.navigationMeta;
  }

  setNavigationMeta(navigationMeta) {
    this.navigationMeta =  navigationMeta;
  }

  getAnalyticsGroupIdOfAnItem(itemId, isCollabPskill) {
    let navigationArray = this.navigationMeta;
    let analyticsOfItemFound = navigationArray.find((navItem)=> navItem['item-code']===itemId).__analytics;
    let analyticsGroupId;
    if(isCollabPskill) {
      analyticsGroupId = analyticsOfItemFound && analyticsOfItemFound.evaluation && analyticsOfItemFound.evaluation.groupId;
    } else {
      analyticsGroupId = analyticsOfItemFound && analyticsOfItemFound.completed && analyticsOfItemFound.completed.groupId;
    }
    return analyticsGroupId;
  }

  getProductClass() {
    return this.classData;
  }
  getProduct() {
    return this.productCode;
  }

  getProductResultsDisplayData(){
    return this.productResultsDisplayData;
  }

  getClass() {
    return this.classId;
  }

  public setIsAssignmentOnlyProduct(isAssignmentOnlyProduct) {
    this.isAssignmentOnlyProduct = isAssignmentOnlyProduct;
  }

  public getIsAssignmentOnlyProduct() {
    return this.isAssignmentOnlyProduct;
  }

  public getIsCBPClass() {
    return this.isCBPClass;
  }

  setXAPIRunnerObject (initParams, eventCallbacks) {
      this.xapiLO = new XAPIRunner(initParams, eventCallbacks);    
  }
  setXAPIAnalyticsObject (analyticsDataObj) {
      this.xapiLOAnalytics = new XAPIAnalytics({serverRoutePrefix: analyticsDataObj.serverRoutePrefix, 
        productCode: analyticsDataObj.dlsProductCode,
        isTestTypeProduct: analyticsDataObj.isTestTypeProduct,
        spaceId : analyticsDataObj.spaceId,
        orgId: analyticsDataObj.orgId,
        classId : analyticsDataObj.dlsClassId,
        isCBPClass: analyticsDataObj.isCBPClass,
        assignedPathId : analyticsDataObj.dlsAssignmentId,
        userDetails: { extUserId: analyticsDataObj.userId },
        userProgressAnalytics: analyticsDataObj.userProgressAnalytics,
        errorCallback: (errorSource, error) => {
          const message = `[Custom] captured failed XAPIRunner http request for ${errorSource} with status ${error.status}...`;
          Raven.captureBreadcrumb({
            message,
            category: 'xhr',
            data: error,
            level: 'error'
          });
          Raven.captureException(message);
        }
    });
  }

  getXAPIRunnerObject() {
      return this.xapiLO;
  }

  setLOInitParams(initParams) {
    this.initParams = initParams;
  }

  getLOInitParams() {
    return this.initParams;
  }
  
  getXAPIAnalyticsObject() {
      return this.xapiLOAnalytics;
  }
  setIsPreviewMode(isPreviewMode) {
    this.isPreviewMode = isPreviewMode;
  }
  getIsPreviewMode() {
    return this.isPreviewMode;
  }

  setSegment(segment) {
    this.segment = segment;
  }

  getSegment() {
    return this.segment;
  }

  public terminateActivityView(): Promise<boolean> {
    if (this.isPreviewMode) {
      return Promise.resolve(true);
    }
    return this.getXAPIAnalyticsObject().flushStateAndStatements().then((response)=> {
        return true;  
    },(error)=> {
      return true;
    }).catch((error)=> {
      return true;
    });
  }

  // Function to check test type product
  isTestTypeComponent(bundleProduct) {
    const resultsDisplayScoreDetailFormat = bundleProduct['results-display'] && bundleProduct['results-display']['score-detail-format'] ? bundleProduct['results-display']['score-detail-format'] : this.scoreDetailFormatTypes.none;
    const productModelType = bundleProduct['ext-product'] && bundleProduct['ext-product']['model'];

    return resultsDisplayScoreDetailFormat === this.scoreDetailFormatTypes.mock || productModelType === this.productModelTypes.test;
  }

  // Return Updated signed URL if signedURL is about to expire else return empty string
  async checkExpiryAndReturnUpdatedSignedURL(signedURL, {audioDuration = undefined, fetchSignedUrlForInterBucket = false, timestampQueryParamRequired = true} = {}) {
    let isNewSignedUrlNeeded = false;
    let updatedSignedURL = '';
    const urlValidityPeriod = this.getUrlValidityPeriod(audioDuration);

    const audioURL = new URL(signedURL);
    const expiryTimestamp = this.getExpiryTimeFromSignedURL(audioURL);
    if (expiryTimestamp) {
      // current time
      const currentTimestamp = (new Date().getTime())/1000;
      const secondsLeft = expiryTimestamp - currentTimestamp;

      // Check if signed URL is about to expire i.e the difference of expiring minutes is less than the audio duration
      isNewSignedUrlNeeded = !audioDuration || (secondsLeft < audioDuration);
    } else { //in case Expire query params is not there then generate new signed URL
      isNewSignedUrlNeeded = true;
    }
    if(isNewSignedUrlNeeded){
      try {
        if (fetchSignedUrlForInterBucket) {
          const response = await this.recordingHelperService.getSignedUrlsForRecordingInInterBucket(audioURL.pathname.substring(1), urlValidityPeriod).toPromise();
          updatedSignedURL = response.signedUrl;
        } else {
          const response = await this.recordingHelperService.getSignedURL({
            url: `${audioURL.origin}${audioURL.pathname}`,
            timestampQueryParamRequired: timestampQueryParamRequired,
            urlValidityPeriod
          });
          updatedSignedURL = response.signedURL;
        }
      } catch(error) {
        return updatedSignedURL;
      }
    }
    return updatedSignedURL;
  }

  public existsActivityTiming(activityId: string) {
    return !!this.activityTimings[activityId];
  }

  public addActivityTiming(activityId: string, metric: string, ts = Date.now()) {
    if (!this.activityTimings[activityId]) {
      this.activityTimings[activityId] = {};
    }
    this.activityTimings[activityId][metric] = ts;
  }

  public getActivityTiming(activityId: string): any {
    const timingData = this.activityTimings[activityId];
    if (timingData && timingData.launchTs) {
      Object.keys(timingData).forEach(key => {
        if (key !== 'launchTs') {
          timingData[key] = timingData[key] - timingData.launchTs;
        }
      });
    }
    return timingData;
  }

  public deleteActivityTiming(activityId: string) {
    delete this.activityTimings[activityId];
  }

  /**
   * Get the dynamic URL validity period based on the audio duration (including 20% buffer time).
   * Minimum URL validity period is 10 seconds.
   * If no audio duration is provided, the function will return undefined (this should use the default 
   * validity period i.e. 24 minutes).
   * @param audioDuration - Audio duration in seconds
   * @returns URL validity period in seconds
   */
  public getUrlValidityPeriod(audioDuration?: number) { 
    if (audioDuration)
      return (1.2 * audioDuration) > 10 ? (1.2 * audioDuration) : 10;
  }

  /**
   * Get expiry time from the signed URL
   * The signed URL can have two types of expiry time query parameters:
   * 1. Expires query parameter (from cloudfront signed URL)
   * 2. X-Amz-Date and X-Amz-Expires query parameters (from S3 signed URL)
   * @param audioURL - Signed URL of the audio file
   * @returns - Expiry time of the signed URL in seconds
   */
  private getExpiryTimeFromSignedURL(audioURL: URL) {
    let expiryTimestamp;
    try {
      // Get query parameters
      const queryParams = new URLSearchParams(audioURL.search);
      const xAmzDate = queryParams.get('X-Amz-Date');
      const xAmzExpiry = queryParams.get('X-Amz-Expires');
      const expiry = queryParams.get('Expires');

      // Get Expiry time from signedURL
      if (expiry) {
        expiryTimestamp = expiry as any;
      } else if (xAmzDate && xAmzExpiry) {
        // Convert to standard ISO date format
        const signingIsoDate = xAmzDate.replace(
          /(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/,
          "$1-$2-$3T$4:$5:$6Z"
        );

        const signingTime = new Date(signingIsoDate).getTime() / 1000;
        expiryTimestamp = signingTime + parseInt(xAmzExpiry);
      }

      return expiryTimestamp;
    } catch (_err) {
      return expiryTimestamp;
    }
  }
  /**
   * Show/hide buttons based on container events
   * @param showControls - Array of controls to modify
   * @param containerEvent - Type of container event
   * @param containerEventData - Data related to the container event
   * @param isScompContent - Whether the content is scomp type
   * @param isCreateAssignmentFlow - Whether this is being called from create-assignments context
   * @param nextActivityBtn - Reference to next activity button (can also serve as back to assignments button in case of SComp assignment)
   * @returns Updated showControls array
   */
  public handleControlEvent(
    showControls: any[],
    containerEvent: string,
    containerEventData: any,
    isScompContent: boolean,
    isCreateAssignmentFlow: boolean,
    nextActivityBtn: any
  ): any[] {
    if (
      // If the button should not be visible
      !containerEventData.state &&
      // For SComp content, check visible flag
      !(isScompContent && containerEventData.visible)
    ) {
      /* Hide the existing button */
      return showControls.filter((control) => {
        return control.type !== containerEventData.control;
      });
    }

    // Check if the button is already present
    const existingControlIndex = showControls.findIndex((control) => {
      return control.type === containerEventData.control;
    });

    // For SComp content, update the existing button
    if (existingControlIndex !== -1 && isScompContent) {
      showControls[existingControlIndex].isActive = containerEventData.active;
      return showControls;
    }

    // For rest of scenarios, we need to show a new button
    const controlData = {
      'containerType': containerEvent,
      'type': containerEventData.control,
      'text': (containerEventData.meta?.buttonText) ? containerEventData.meta.buttonText : containerEventData.control,
      'isSecondary': containerEventData.meta?.variant === 'secondary',
      'isActive': containerEventData.active !== false
    };

    /* Set translations keys for the hardcoded buttons text that we get from xapirunner */
    switch (controlData.text) {
      case 'Check': controlData.text = isCreateAssignmentFlow ? 'TEACHER.CREATE_ASSIGNMENTS.CHECK' : 'LEARNER.ACTIVITYLAUNCH.CHECK'; break;
      case 'Next': controlData.text = isCreateAssignmentFlow ? 'TEACHER.CREATE_ASSIGNMENTS.NEXT' : 'LEARNER.ACTIVITYLAUNCH.NEXT'; break;
      case 'Review': controlData.text = isCreateAssignmentFlow ? 'TEACHER.CREATE_ASSIGNMENTS.REVIEW' : 'LEARNER.ACTIVITYLAUNCH.REVIEW'; break;
      case 'Previous': controlData.text = isCreateAssignmentFlow ? 'TEACHER.CREATE_ASSIGNMENTS.PREVIOUS' : 'LEARNER.ACTIVITYLAUNCH.PREVIOUS'; break;
      case 'Read conversation': controlData.text = isCreateAssignmentFlow ? 'TEACHER.CREATE_ASSIGNMENTS.READ_CONVERSATION' : 'LEARNER.ACTIVITYLAUNCH.READ_CONVERSATION'; break;
      case 'Close': controlData.text = 'TEACHER.CREATE_ASSIGNMENTS.CLOSE'; break;
    }

    if (controlData.type === 'goPrev') {
      // Always show previous button on left most side
      showControls.unshift(controlData);
    } else if (controlData.type === 'goNext') {
      // Always show next button on right most side
      showControls.push(controlData);
    } else {
      let goNextIndex = -1, seeTopicsControlIndex = -1;
      // Find index of 'seeTopics' and 'goNext' button if they exist
      for (let i = 0; i < showControls.length; i++) {
        if (showControls[i].type === 'seeTopics') {
          seeTopicsControlIndex = i;
        } else if (showControls[i].type === 'goNext') {
          goNextIndex = i;
        }
      }

      // Update the secondary status of nextActivityBtn according to readConversation btn
      // nextActivityBtn can be in either 'nextActivity' or 'backToAssignments' btn
      if (isScompContent && controlData.type === 'readConversation' && nextActivityBtn?.show) {
        nextActivityBtn.isSecondary = !controlData.isSecondary;
      }

      // For non-scomp content, if goNext button exists, insert the new control before it
      if (!isScompContent && goNextIndex !== -1) {
        showControls.splice(goNextIndex, 0, controlData);
      } else if (isScompContent && !controlData.isSecondary && seeTopicsControlIndex !== -1) {
        // For scomp content, if seeTopics button exists and the new control is not secondary,
        // make seeTopics secondary and add the new control before it
        showControls[seeTopicsControlIndex].isSecondary = true;
        showControls.unshift(controlData);
      } else {
        // For other scenarios, add the new control at the end
        showControls.push(controlData);
      }
    }

    return showControls;
  }
}